import { v4 as uuid } from "uuid";
import Vue from "vue";
const vm = new Vue();

export default {
  namespaced: true,
  state: {
    accounts: [],
    user_type: "",
    user_code: "",
    user_name: "",
    user_picture: "",
    play_sound: "OFF",
    theme_chart: {
      dark: {
        font_color: "#f5f5f6",
        chart_1: "",
        chart_2: "rgba(32, 42, 55, 0.1)",
        line: "#222936",
      },
      light: {
        font_color: "#0b0f13",
        chart_1: "",
        chart_2: "rgba(255, 255, 255, 0.2)",
        line: "#eaebed",
      },
    },
    plan_data: {},
    license_data: null,
    extensions: [],
    messages: [],
    websocket_connected: null,
    id: undefined,
    theme_key: uuid(),
    ui_theme: "DARK",
    side_menus: null,
  },
  getters: {
    getUiTheme(state) {
      return state.theme_key;
    },
    ui_theme(state) {
      return state.ui_theme;
    },
    getUserPlan(state) {
      return state.plan_data;
    },
    getLicenseData(state) {
      return state.license_data;
    },
    getExtensions(state) {
      return state.extensions;
    },
    getConfigs(state) {
      return state;
    },
    hasUnreadMessages(state) {
      return state.messages.some((item) => item.status === "UNREAD");
      // return true;
    },
    getWebsocketIsConnected(state) {
      return state.websocket_connected;
    },
    getId(state) {
      return state.id;
    },
  },

  mutations: {
    SET_UI_THEME(state, payload) {
      state.ui_theme = payload;
    },
    SET_WEBSOCKET_IS_CONNECTED(state, payload) {
      state.websocket_connected = payload;
    },
    SET_USER_CONFIG(state, payload) {
      state.accounts = payload?.accounts;
      // state.ui_theme = payload?.ui_theme;
      state.user_type = payload?.user_type;
      state.user_code = payload?.user_code;
      state.user_name = payload?.user_name;
      state.user_picture = payload?.user_picture;
      state.play_sound = payload?.play_sound;
      state.plan_data = payload?.plan_data;
      state.extensions = payload?.extensions;
      state.configs_loaded = true;
      state.license_data = payload?.license_data;
      state.side_menus = payload.side_menus;
    },
    CHANGE_THEME(state) {
      state.theme_key = uuid();
    },
    POST_SOUND(state, payload) {
      state.play_sound = state.play_sound == "OFF" ? "ON" : "OFF";
    },
    SET_MESSAGES(state, payload) {
      state.messages = payload;
    },
    SET_ID(state, payload) {
      state.id = payload;
    },
  },
  actions: {
    setUiTheme({ commit }, payload) {
      commit("SET_UI_THEME", payload);
    },
    setWebsocketIsConnected({ commit }, payload) {
      commit("SET_WEBSOCKET_IS_CONNECTED", payload);
    },

    async setUserConfig({ commit, dispatch }) {
      try {
        const { data } = await vm.$api.get(vm.$endpoint.USER_CONFIGS);
        commit("SET_USER_CONFIG", data);
        await dispatch("accountTypes/fetchAccounts", data.accounts, {
          root: true,
        });
        return data;
      } catch (err) {
        console.error(err);
      }
    },

    changeTheme({ commit }, payload) {
      localStorage.setItem("ui_theme", payload.toUpperCase());
      // console.log(localStorage.getItem("ui_theme"));
      commit("CHANGE_THEME");
    },

    postSoundAlert({ commit }, payload) {
      let param = {
        pref_type: "play_sound",
        pref_data: payload,
      };
      vm.$api
        .post(`${vm.$endpoint.UPDATE_PREFERENCE}`, param)
        .then((res) => {
          // console.log(res);
        })
        .catch((err) => {
          console.error(err);
        });

      commit("POST_SOUND", payload);
    },

    async setMessages({ commit }) {
      try {
        const { data } = await vm.$api.get(vm.$endpoint.GET_NOTIFICATIONS);
        commit("SET_MESSAGES", data);
        return data;
      } catch (err) {}
    },
    setId({ commit }, payload) {
      commit("SET_ID", payload);
    },
  },
};
